export default __webpack_public_path__ + "static/media/Accelerons2014.34334544.png";